import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectToken } from '../utility/Redux/security';
import {
  selectPrefix,
  selectTableMasterPrefix,
  selectWidth,
} from '../utility/Redux/profile';
import { useState } from 'react';

import axios from 'axios';
import { useEffect } from 'react';
import { useFocus } from '../utility/hooks/hooks';
import {
  setAlertWithTitle,
  setModWorkerMasterHelpStatus,
  setSessionExpired,
  setSpinnerLoading,
} from '../utility/Redux/modal';
import GeniustextInput from '../utility/component/mastertext';
import {
  ModifyButton,
  SaveButton,
  UndoButton,
} from '../utility/component/SNAA_buttons';
import GeniusDatagrid from '../utility/component/datagrid.js/geniusDatagrid';
import { useNavigate } from 'react-router-dom';
import { toProperCase } from '../utility/component/format';
import Departmenthelp from '../help/departmenthelp';
import EmployeeMasterHelp from '../help/employeeMasterHelp';
import { CallAPIPromise } from '../utility/func/func';
import { AccountTreeOutlined, Close, FormatListBulletedRounded } from '@mui/icons-material';
import './employeeDepartmentMaster.css';

const EmpDepartMaster = () => {
  const dispatch = useDispatch();
  const [departmentName, setDeaprtmentName] = useState('');
  const [employeeName, setEmployeeName] = useState('');
  const [employeMobile, setEmployeeMobile] = useState('');
  const [employeeCode, setEmployeeCode] = useState('');
  const token = useSelector(selectToken);
  const windowWidth = useSelector(selectWidth);
  const [id, setId] = useState();
  const [departmemnthelpStatus, setDepartmentHelpStatus] = useState(false);
  const [secName, setSecName] = useState();
  const [rows, setRows] = useState([]);
  const [secError, setSecError] = useFocus();

  const columns = [
    {
      field: 'CODE',
      type: 'string',
      renderHeader: (params) => <div>Code</div>,
      width: 60,
      headerAlign: 'center',
      align: 'left',
      renderCell: (params) => {
        const runningCaseValue = params.value;
        return <div>{runningCaseValue}</div>;
      },
    },
    {
      field: 'DEPARTMENT_NAME',
      type: 'string',
      renderHeader: (params) => <div>Department</div>,
      width: windowWidth > 764 ? 200 : 300,
      headerAlign: 'center',
      align: 'left',
      renderCell: (params) => {
        const runningCaseValue = params.value;
        return <div>{runningCaseValue}</div>;
      },
    },
    {
      field: 'EMPLOYEE_NAME',
      type: 'string',
      renderHeader: (params) => <div>Employee Name</div>,
      width: windowWidth > 764 ? 200 : 300,
      headerAlign: 'center',
      align: 'left',
      renderCell: (params) => {
        const runningCaseValue = params.value;
        return <div>{runningCaseValue}</div>;
      },
    },
    {
      field: 'MOBILE',
      type: 'string',
      renderHeader: (params) => <div>Mobile</div>,
      width: windowWidth > 764 ? 130 : 130,
      headerAlign: 'center',
      align: 'left',
      renderCell: (params) => {
        const runningCaseValue = params.value;
        return <div>{runningCaseValue}</div>;
      },
    },
  ];
  const masterPrefix = useSelector(selectTableMasterPrefix);

  const getData = async () => {
    // dispatch(setSpinnerLoading('Loading'));
    dispatch(setSpinnerLoading('Loading'));
    const data = {
      table_prefix_master: masterPrefix,
      DEPARTMENT_NAME: departmentName,
    };
    CallAPIPromise('/api/masters/listEmployeeInDepartment', data)
      .then((p) => {
        setRows(p.data.response);
      })
      .catch((error) => {
        console.log(error.response.data.name);
        if (error.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
          console.log(error.response);
        }
      })
      .finally(() => {
        setSecError();
        dispatch(setSpinnerLoading(false));
      });
  };
  const undo = () => {
    setDeaprtmentName('');
    setEmployeeCode('');
    setEmployeeName('');
    setEmployeeMobile('');
    setId('');
  };
  useEffect(() => {
    getData();
  }, [departmentName]);
  const saveSectionMasterApi = () => {
    if (employeeName) {
      const isDup = rows.filter(
        (r) =>
          r.EMPLOYEE_CODE === employeeCode &&
          r.DEPARTMENT_NAME === departmentName
      );

      if (isDup[0] && !id) {
        dispatch(
          setAlertWithTitle({
            title: 'Alert',
            msg: 'Employee already exist',
          })
        );
      } else {
        const data = {
          table_prefix_master: masterPrefix,
          CODE: id ? id : '',
          EMPLOYEE_CODE: employeeCode,
          EMPLOYEE_NAME: employeeName,
          MOBILE: employeMobile,
          DEPARTMENT_NAME: departmentName,
        };

        id
          ? dispatch(setSpinnerLoading('Updating'))
          : dispatch(setSpinnerLoading('Saving'));
        CallAPIPromise(`/api/masters/saveEmployeeDepMaster`, data)
          .then(async function (response) {
            if (!response.data.error) {
              id
                ? dispatch(
                    setAlertWithTitle({
                      title: 'Success.',
                      msg: 'Data Updated successfully.',
                      lottie: 'success',
                    })
                  )
                : dispatch(
                    setAlertWithTitle({
                      title: 'Success.',
                      msg: 'Data Saved successfully.',
                      lottie: 'success',
                    })
                  );
            } else {
              dispatch(
                setAlertWithTitle({
                  title: 'Error 112',
                  msg: response.data.error,
                })
              );
            }
          })
          .catch(function (error) {
            if (error.response.data.name === 'TokenExpiredError') {
              dispatch(setSessionExpired(true));
              console.log(error.response);
            }
            console.log(error);
            dispatch(
              setAlertWithTitle({
                title: 'ERROR',
                msg: 'Something went wrong.',
                lottie: 'reject',
              })
            );
          })
          .finally(() => {
            dispatch(setSpinnerLoading(false));
            undo();

            getData();
          });
      }
    } else {
      dispatch(
        setAlertWithTitle({
          title: 'Alert',
          msg: 'Please enter employee name',
        })
      );
    }
  };
  const navigate = useNavigate();
  return (
    <main className="employee-department-page">
      <div className="employee-department-shell">
        <header className="employee-department-hero"><div className="employee-department-hero__content"><span className="employee-department-hero__icon"><AccountTreeOutlined /></span><div><span>Team & production</span><h1>Employee Department Master</h1><p>Assign employees to the right departments and keep teams organised.</p></div></div><button type="button" onClick={() => navigate('/masters')} aria-label="Back to Masters" title="Back to Masters"><Close fontSize="small" /></button></header>
        <section className="employee-department-card employee-department-entry">
          <div className="employee-department-card__heading"><div><span>Assignment details</span><h2>{id ? 'Update employee assignment' : 'Create employee assignment'}</h2></div><small>{id ? 'Editing selected assignment' : 'New assignment'}</small></div>
          <div className="employee-department-fields">
            <div className="employee-department-field">
            <GeniustextInput
              title={'Department Name'}
              search={() => {
                setDepartmentHelpStatus(true);
              }}
              width={'100%'}
              type={'text'}
              value={departmentName}
              readOnly={true}
              refrance={secError}
            />
            </div>
            <div className="employee-department-field employee-department-employee">
            <GeniustextInput
              title={'Employee Name'}
              width={'100%'}
              type={'text'}
              search={() => {
                if (!id) {
                  if (departmentName) {
                    dispatch(setModWorkerMasterHelpStatus(true));
                  } else {
                    dispatch(
                      setAlertWithTitle({
                        title: 'Alert',
                        msg: 'Please select department first.',
                      })
                    );
                  }
                }
              }}
              value={employeeName}
              readOnly={true}
              refrance={secError}
            />
            </div>
            <div className="employee-department-field">
                <GeniustextInput
                  title={'Mobile'}
                  width={'100%'}
                  type={'number'}
                  readOnly={true}
                  value={employeMobile}
                  refrance={secError}
                />
            </div>
          </div>
          <div className="employee-department-actions">{id ? <ModifyButton onClick={saveSectionMasterApi} /> : <SaveButton onClick={saveSectionMasterApi} />}<UndoButton onClick={undo} /></div>
        </section>
        <section className="employee-department-card employee-department-table-card">
          <div className="employee-department-card__heading"><div><span>Saved assignments</span><h2>Employee department catalogue</h2></div><small className="employee-department-count"><FormatListBulletedRounded fontSize="small" /> {rows.length} assignments</small></div>
          <div className="employee-department-grid">
            <GeniusDatagrid
              rowID={(e) => e.CODE}
              onRowClick={(p) => {
                setId(p.row.CODE);
                setDeaprtmentName(p.row.DEPARTMENT_NAME);
                setEmployeeCode(p.row.CODE);
                setEmployeeName(p.row.EMPLOYEE_NAME);
                setEmployeeMobile(p.row.MOBILE);
              }}
              columns={columns}
              list={rows}
            />
          </div>
        </section>
          <Departmenthelp
            status={departmemnthelpStatus}
            handleClose={() => {
              setDepartmentHelpStatus(false);
            }}
            onRowClick={(p) => {
              setDepartmentHelpStatus(false);
              setDeaprtmentName(p.row.DEPARTMENT_NAME);
            }}
          />
          <EmployeeMasterHelp
            onRowClick={(p) => {
              dispatch(setModWorkerMasterHelpStatus(false));
              setEmployeeName(p.row.employee_name);
              setEmployeeMobile(p.row.mobile);
              setEmployeeCode(p.row.code);
            }}
          />
      </div>
    </main>
  );
};

export default EmpDepartMaster;
